<template>
  <div class="render-item"
       :class="{
         italic: italic == 'all',
         strong: strong == 'all',
         ['full-line']: fullLine,
       }"
       :style="{
         fontWeight: strong,
         lineHeight: lineHeight,
         color: currentRenderColor
       }">
    <!-- 换行 -->
    <br v-if="wrap">  
    <!-- 首行缩进 -->
    <template v-for="i in indent">&emsp; </template>
    <span class="reference-position"> </span>
    <!-- 左标签 -->
    <span :class="{
            italic: italic == 'label',
            strong: strong == 'label',
          }"
          v-show="labelPosition=='left'">{{labelText}}</span>
          <slot></slot>
          <span :class="{
            italic: italic == 'label',
            strong: strong == 'label',
          }"
          v-show="labelPosition=='right'">{{labelText}}</span>
  </div>
</template>

<script>
export default {
  props: {
    //  标签文本内容
    labelText: {
      type: String,
      default: ""
    },
    //  标签位置(相对于表单项内容)
    labelPosition: {
      type: String,
      default: "left"
    },
    //  行高
    lineHeight: {
      type: String,
      default: "",
    },
    //  加粗: { all:全部加粗, label:标签加粗, value:内容加粗 }
    strong: {
      type: String,
      default: ""
    },
    //  斜体: { all:全部加粗, label:标签加粗, value:内容加粗 }
    italic: {
      type: String,
      default: ""
    },
    //  缩进
    indent: {
      type: Number,
      default: 0
    },
    // 缩进大于1
    fullLine: {
      type: Boolean,
      default: false
    },
    // 换行
    wrap: {
      type: Boolean,
      default: false
    },
    // 哪里变色
    whereColor: {
      type: String,
      default: 'all'
    },
    // 渲染颜色
    renderColor: {
      type: String,
      default: '#5c5c5c'
    }
  },
  computed: {
    /**
    * @name 渲染颜色计算
    * @return { string } 渲染颜色
    * @author liuguisheng
    * @version 2020-06-23 17:18:14 星期二
    */
    currentRenderColor () {
      let { whereColor, renderColor} = this;
      return whereColor == 'label' || whereColor == 'all' ? renderColor : "#5c5c5c"
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/base_package/RenderFormItem.vue